export default __webpack_public_path__ + "static/media/rocky-linux.1dc51887.png";